// ─────────────────────────────────────────────────────────────────────────
//  In-app confirm / prompt — promise based, NEVER a native browser dialog.
//  <ConfirmDialogHost/> (mounted once in App.jsx) registers the opener.
//  Usage:  if (!(await window.appConfirm("Delete this?"))) return;
//          const val = await window.appPrompt("Enter reason");   // null on cancel
// ─────────────────────────────────────────────────────────────────────────
let _opener = null;
export function registerConfirmOpener(fn) { _opener = fn; }

const isDanger = (m) =>
  /\b(delete|remove|deactivate|block|revoke|cancel this|cannot be undone|permanently)\b/i.test(String(m || ""));

export function appConfirm(message, opts = {}) {
  if (message && typeof message === "object") { opts = message; message = opts.message; }
  const danger = opts.danger !== undefined ? opts.danger : isDanger(message);
  const cfg = {
    type: "confirm",
    message: String(message ?? ""),
    title: opts.title || "Please confirm",
    confirmText: opts.confirmText || "Confirm",
    cancelText: opts.cancelText || "Cancel",
    danger,
  };
  if (_opener) return _opener(cfg);
  return Promise.resolve(true); // host not mounted → don't block the flow
}

export function appPrompt(message, defaultValue = "", opts = {}) {
  const cfg = {
    type: "prompt",
    message: String(message ?? ""),
    title: opts.title || "Enter details",
    defaultValue: defaultValue == null ? "" : String(defaultValue),
    placeholder: opts.placeholder || "",
    confirmText: opts.confirmText || "OK",
    cancelText: opts.cancelText || "Cancel",
    inputType: opts.inputType || "text",
    danger: !!opts.danger,
  };
  if (_opener) return _opener(cfg);
  return Promise.resolve(null); // host not mounted → behave like a cancelled prompt
}
